import { parseEphemeralPartnerIdentifiers } from 'services/webediErrors/annotationItems/parseEphemeralPartnerIdentifiers';
import { MessageV2DTO, PartyIdentifierDTO } from 'support/types';

export type EphemeralPartnerAnnotation = {
  id: string;
  partyKey: string;
  name: string;
  identifiers: Array<PartyIdentifierDTO>;
};

export const findEphemeralPartnerAnnotation = (message: MessageV2DTO): EphemeralPartnerAnnotation | undefined => {
  const annotations = message.annotations ?? [];
  const match = annotations.find(
    (annotation) =>
      annotation.type === 'WARNING' && annotation.value.code === 'EPHEMERAL_PARTNER' && annotation.resolved_at === null,
  );
  if (!match) {
    return undefined;
  }

  const normalizedPath = match.path.replace(/^\$\.?/, '');
  const partyKey = normalizedPath.match(/^parties\.(\w+)$/)?.[1];
  if (!partyKey) {
    return undefined;
  }

  const currentValue = match.value.current_value;
  const currentValueObj: Record<string, unknown> =
    currentValue && typeof currentValue === 'object' ? (currentValue as Record<string, unknown>) : {};
  const name = typeof currentValueObj.name === 'string' ? currentValueObj.name : '';
  const identifiers = parseEphemeralPartnerIdentifiers(currentValueObj.identifiers);

  return { id: match.id, partyKey, name, identifiers };
};
